import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import type { IExamConfig } from "./getExamConfigList";

/**
 * 특정 시험 설정의 정보를 가져옵니다.
 */
export const apiGetExamConfig = async (id: string) => {
  const response = await apiGet<IExamConfig>(`/exam_configs/${id}`);
  return response.data;
};

/**
 * 특정 시험 설정의 정보를 React Query를 통해 가져오는 훅
 */
export const useQueryGetExamConfig = (id: string, options = {}) => {
  return useQuery({
    queryKey: ["examConfig", id],
    queryFn: async () => {
      return await apiGetExamConfig(id);
    },
    ...options,
  });
};

export default useQueryGetExamConfig;
